<mat-form-field class="full-width">
    <mat-label>Departamentos</mat-label>
    <input type="text" matInput (input)="filterChanged($event)" [matAutocomplete]="auto">
    <mat-autocomplete autoSelectActiveOption #auto="matAutocomplete" [displayWith]="displayFn"
        (optionSelected)="onOptionSelected($event)">
        <mat-option disabled style="display: none;">Seleccione un item</mat-option>
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <mat-tree-node *matTreeNodeDef="let node">
                <mat-option [value]="node" style="width: 100%;" matTreeNodePadding> {{node.nombre}}</mat-option>
            </mat-tree-node>
            <mat-tree-node *matTreeNodeDef="let node; when: hasChild">
                <mat-option [value]="node" class="d-content" style="width: 100%;" matTreeNodePadding>
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.nombre" type="button">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                    </button>
                    <span> {{node.nombre}}</span>
                </mat-option>
            </mat-tree-node>
        </mat-tree>
    </mat-autocomplete>
</mat-form-field>